import React from 'react';
var IMG = function (_a) {
    var className = _a.className, src = _a.src;
    return React.createElement("img", { alt: "triangle", className: className, src: src });
};
export { IMG };
